import { colors } from '../../styles/stylesheets';
import iconCheckmark from '../../assets/icons/general/checkmark.svg';

export const allState = {
  active: {
    status: 'active',
    color: colors.info,
    icon: undefined,
  },
  prev: {
    status: 'prev',
    color: colors.greyDark,
    icon: iconCheckmark,
  },
  next: {
    status: 'next',
    color: colors.greyLight,
    icon: undefined,
  },
};
